import { afterNextRender, Directive, ElementRef, inject, output } from '@angular/core';

@Directive({
  selector: '[insideViewport]',
  standalone: true,
})
export class InsideViewportDirective {
  readonly insideViewport = output<boolean>();
  #el = inject<ElementRef<HTMLElement>>(ElementRef);

  constructor() {
    afterNextRender(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.insideViewport.emit(entry.isIntersecting);
        });
      });

      observer.observe(this.#el.nativeElement);
    });
  }
}
